import { extract_error_message } from '@/utils/api_response_helpers';
import {
  update_main_section,
} from '@/services/main_section_service';
import {
  UPDATE_FORM_SECTION_URL,
  get_request_config,
} from '@/utils/system_constants/constant.js';
import axios from 'axios';

export function resolveEditedSectionContext(ctx) {
  const edit_context = {
    section_id: Number(ctx.current_edit_section.section_id),
    section_name: String(ctx.current_edit_section.name || '').trim(),
  };
  return edit_context;
}

export function resolveEditedMainSectionContext(ctx) {
  const edit_context = {
    main_section_description: String(ctx.current_edit_main_section.main_section_description || '').trim() || null,
    main_section_id: Number(ctx.current_edit_main_section.main_section_id),
    main_section_name: String(ctx.current_edit_main_section.main_section_name || '').trim(),
  };
  return edit_context;
}

export async function saveEditedSection(ctx) {
  const edit_context = resolveEditedSectionContext(ctx);

  if (!edit_context.section_id) {
    ctx.show_error('Please select a valid main section first.');
    return;
  }

  ctx.editing_main_section = true;

  const loader = await ctx.show_loader('Updating sub section...');

  try {
    await performSaveEditedSection(ctx, edit_context);
  } finally {
    await ctx.close_loader(loader);
    ctx.editing_main_section = false;
  }
}

async function performSaveEditedSection(ctx, edit_context) {
  try {
    const response = await axios.put(
      UPDATE_FORM_SECTION_URL,
      {
        name: edit_context.section_name,
        section_id: edit_context.section_id,
      },
      get_request_config()
    );

    const parsed_response = ctx.parse_response_data(response);

    const success = parsed_response?.status === 'success';

    if (!success) {
      ctx.show_error(
        parsed_response?.message || 'Failed to update sub section.'
      );
      return;
    }

    ctx.show_success(
      parsed_response.message || 'Sub section updated successfully.'
    );

    ctx.close_modal('edit_sub_section_modal');

    await ctx.load_form_sections();

    const refreshed_section = ctx.sections.find((item) => {
      return Number(item.backend_id ?? item.id) === Number(edit_context.section_id);
    });

    if (refreshed_section) {
      refreshed_section.expanded = true;
    }
  } catch (error) {
    ctx.show_error(
      extract_error_message(error, 'Failed to update sub section.')
    );
  }
}

export async function saveEditedMainSection(ctx) {
  const edit_context = resolveEditedMainSectionContext(ctx);

  if (!edit_context.main_section_id) {
    ctx.show_error('Please select a valid main section first.');
    return;
  }

  ctx.editing_main_section = true;

  const loader = await ctx.show_loader('Updating main section...');

  try {
    await performSaveEditedMainSection(ctx, edit_context);
  } finally {
    await ctx.close_loader(loader);
    ctx.editing_main_section = false;
  }
}

async function performSaveEditedMainSection(ctx, edit_context) {
  try {
    const parsed_response = await update_main_section({
      main_section_id: edit_context.main_section_id,
      main_section_name: edit_context.main_section_name,
      main_section_description: edit_context.main_section_description,
    });

    const success = parsed_response?.status === 'success';

    if (!success) {
      ctx.show_error(
        parsed_response?.message || 'Failed to update main section.'
      );
      return;
    }

    ctx.show_success(
      parsed_response.message || 'Main section updated successfully.'
    );

    ctx.close_modal('edit_main_section_modal');

    await ctx.load_main_sections();

    ctx.expand_main_section_by_id(edit_context.main_section_id);
  } catch (error) {
    ctx.show_error(
      extract_error_message(error, 'Failed to update main section.')
    );
  }
}
